import React from 'react';
import './UserAgreementModal.css';

interface UserAgreementModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const UserAgreementModal: React.FC<UserAgreementModalProps> = ({ open, onClose, title }) => {
  if (!open) return null;

  return (
    <div className="ua-overlay" onClick={onClose}>
      <div className="ua-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ua-header">
          <h2>{title}</h2>
          <button className="ua-close" onClick={onClose}>&times;</button>
        </div>
        <div className="ua-body">
          <h3>Amovent Convention</h3>

          <h4>1. Definitions</h4>
          <p><strong>Service</strong> — the site you are on now, amovent.com</p>
          <p><strong>User, Service User</strong> — a person who owns an account on Service and uses it</p>

          <h4>2. Acceptance of Terms</h4>
          <p>You use this service as-is. If you don't agree with something, you can deactivate your account and stop using the service.</p>

          <h4>3. User Data</h4>
          <p>Your data that you produce using this service may be kept on the service.</p>

          <h4>4. Equality</h4>
          <p>Users are all equals. There are no VIP accounts or special features for special persons. Admin is the only role with additional functions.</p>

          <h4>5. Liability</h4>
          <p>The creator, admin, Service Team and other people who keep the site working are not responsible for the events, user collaboration between each other or any other things Users do here. The Amovent Team is only responsible for keeping the site working.</p>
          <p>Event responsibility is on the Event creator and may be partially on Users who moderate or participate in the Event.</p>

          <h4>6. Rights and Obligations</h4>
          <p>You must behave correctly and with respect towards other Users of the Service. Admin may block or deactivate your account if your behaviour does not meet requirements of this Convention or sanity.</p>

          <h4>7. Cookies</h4>
          <p>The Service uses cookies to store your language preference and authentication session. These are essential for the Service to function and are not used for tracking or advertising purposes.</p>

          <h4>8. Account Termination</h4>
          <p>You may deactivate your account at any time. Admin reserves the right to suspend or deactivate accounts that violate these terms.</p>

          <p className="ua-date">2026-04-14</p>
        </div>
      </div>
    </div>
  );
};

export default UserAgreementModal;